import ProfileNavIcon from '@/assets/images/profile-nav-icon.svg';
import ProfileNavIconLatino from '@/assets/images/profile-nav-icon-latino.svg';
import IconWithFloatingContent from '../../EnkiDummyUI/IconWithFloatingContent';
import { isLatinoChannel } from '@/utils/common/latino-app';
import { ReactNode, useState } from 'react';

interface ProfileIconProps {
  altText: string;
  onClick?: () => void;
  counterNode?: ReactNode;
  dataTestId?: string;
}

const ProfileIcon: React.FC<ProfileIconProps> = ({ onClick, altText, counterNode, dataTestId }) => {
  const [showRewardsBadge, setShowRewardsBadge] = useState<boolean>(false);

  const isLatino = isLatinoChannel();

  const renderRewardsBagde = () => {
    // TODO: handle rewards UI
    return null;
  };

  return (
    <IconWithFloatingContent
      icon={<img className="w-[24px] h-[24px]" src={isLatino ? ProfileNavIconLatino : ProfileNavIcon} alt={altText} />}
      floatingContent={showRewardsBadge ? renderRewardsBagde() : null}
      onClick={onClick}
      counterNode={counterNode}
      dataTestId={dataTestId}
    />
  );
};

export default ProfileIcon;
